import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'time'
})

export class TimePipe implements PipeTransform {
  transform(value: string, format: string = ''): string {
    if (!value || value === '') return '';
    return moment(value, 'HH:mm').format('HH:mm');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/time.pipe.ts